import React, { useEffect, useState } from "react";
import {
  Button,
  FormGroup,
  FormControl,
  FormLabel,
  Modal
} from "react-bootstrap";
import "./LoginDialog.scss";
import logo from "../../assets/xeester.png";
import { useTranslation } from "react-i18next";
import ReCAPTCHA from "react-google-recaptcha";
import i18n from "i18next";

function LoginDialog({ show, handleClose, userLogged }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [error, setError] = useState(false);

  let subscribeUrl = window.serverUrl+"";
  let forgotUrl = window.serverUrl+"";
  switch (i18n.language) {
    case "fr": {
      subscribeUrl += "/fr/abonnements";
      forgotUrl += "/fr/cb-forgot-login";
      break;
    }
    case "en": {
      subscribeUrl += "/en/subscriptions";
      forgotUrl += "/en/cb-forgot-login";
      break;
    }
    case "it": {
      subscribeUrl += "/it/crea-un-account";
      forgotUrl += "/it/cb-forgot-login";
      break;
    }
    case "pt": {
      subscribeUrl += "/pt/subscriptions-pt";
      forgotUrl += "/pt/cb-forgot-login";
      break;
    }
    default: {
      break;
    }
  }

  function onCaptchaChange(value) {
    console.log("Captcha value:", value);
    setCaptcha(value);
  }

  function validateForm() {
    return captcha.length > 0 && username.length > 0 && password.length > 0;
  }

  function handleSubmit(event) {
    event.preventDefault();
    console.log("submit", username);
    localStorage.setItem("username", username);
    //localStorage.setItem("pwd", password);
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: "login=" + username + "&pwd=" + password
    };
    fetch(window.serverUrl+`/social/login.php`, requestOptions)
      .then((r) => r.json())
      .then((_user) => {
        console.log("_user", _user);
        userLogged(_user);
        if (_user.error === 401) {
          console.log("not logged");
          setError(true);
        } else {
          document.location.reload();
        }
      })
      .catch((err) => {
        console.error("fetch problem", err);
        setError(true);
      });
  }

  const { t } = useTranslation();

  useEffect(() => {
    if (show) {
      setUsername("");
      setPassword("");
      setCaptcha("");
    }
    return () => {
      //console.log("login done");
    };
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop
      keyboard={false}
      centered
      dialogClassName="login-dialog"
    >
      <Modal.Body className="login-panel d-flex flex-column align-items-center">
        <div className="error" style={{ display: error ? "inline" : "none" }}>
          {t("replayApp.user.error")}
        </div>
        <div className="close" onClick={handleClose}>
          X
        </div>
        <form onSubmit={handleSubmit}>
          <img id="logo-login" className="img-fluid" src={logo} alt="" />
          <FormGroup controlId={"" + Math.random()}>
            <FormLabel>{t("replayApp.user.username")}</FormLabel>
            <FormControl
              autoFocus
              value={username}
              autoComplete="off"
              onChange={(e) => {
                setUsername(e.target.value);
              }}
            />
          </FormGroup>
          <FormGroup controlId={"" + Math.random()}>
            <FormLabel>{t("replayApp.user.password")}</FormLabel>
            <FormControl
              value={password}
              autoComplete="new-password"
              onChange={(e) => setPassword(e.target.value)}
              type="password"
            />
          </FormGroup>
          <ReCAPTCHA
            sitekey="6LeQLtgZAAAAAJpceTJFoW2fYnA5Lhp6xGcCYs-F"
            theme="dark"
            size="normal"
            onChange={onCaptchaChange}
          />
          <Button
            id="login-button"
            block
            disabled={!validateForm()}
            type="submit"
          >
            {t("replayApp.user.login")}
          </Button>
          <Button
            id="forgot-button"
            block
            type="submit"
            href={forgotUrl}
            target="_blank"
          >
            {t("replayApp.user.forgot")}
          </Button>
          <div className="no-account">{t("replayApp.user.notMemberYet")}</div>
          <Button id="signin-button" block href={subscribeUrl} target="_blank">
            {t("replayApp.user.signUp")}
          </Button>
        </form>
      </Modal.Body>
    </Modal>
  );
}

export default LoginDialog;
